import * as React from 'react';
import {
  ActionButton,
  addRowToPayload,
  fetchApi,
  getInitialValuesExistingRow,
  makeCompoundPayload,
  notifyError,
  notifyResponse,
  useCacheRecord,
} from 'gossamer-front-end';
import { InstitutionMemberInvite, InstitutionMemberInviteRow } from 'cb-model';
import { useNavigate } from 'react-router-dom';

export interface MemberInviteDeleteButtonProps {
  institution_member_invite_id: string;
}

export const MemberInviteDeleteButton: React.FC<MemberInviteDeleteButtonProps> = (props) => {
  const navigate = useNavigate();
  const { data, error } = useCacheRecord<InstitutionMemberInviteRow>(
    InstitutionMemberInvite,
    props.institution_member_invite_id,
  );
  if (!!error) {
    console.error(error);
  }
  return (
    <ActionButton
      label="Cancel Invite"
      size="sm"
      variant="danger"
      waiting={!data}
      execute={async (resetCache) => {
        try {
          const payload = makeCompoundPayload('save');
          const row = getInitialValuesExistingRow(InstitutionMemberInvite, data);
          row._deleting = true;
          addRowToPayload(payload, InstitutionMemberInvite, row);
          const response = await fetchApi('POST', `/main/~/institution-member-invite-delete`, payload);
          resetCache(InstitutionMemberInvite.id, props.institution_member_invite_id);
          notifyResponse(response);
          navigate('/admin/institution-member/search');
        } catch (e) {
          notifyError(e, 'An error occurred while deleting the member invite');
        }
      }}
    />
  );
};
